"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:no-consecutive-blank-lines ordered-imports align trailing-comma enum-naming
// tslint:disable:whitespace no-unbound-method no-trailing-whitespace
// tslint:disable:no-unused-variable
var base_contract_1 = require("@0x/base-contract");
var json_schemas_1 = require("@0x/json-schemas");
var utils_1 = require("@0x/utils");
var web3_wrapper_1 = require("@0x/web3-wrapper");
var assert_1 = require("@0x/assert");
var ethers = require("ethers");
// tslint:enable:no-unused-variable
/* istanbul ignore next */
// tslint:disable:no-parameter-reassignment
// tslint:disable-next-line:class-name
var DevUtilsContract = /** @class */ (function (_super) {
    __extends(DevUtilsContract, _super);
    function DevUtilsContract(address, supportedProvider, txDefaults, logDecodeDependencies, deployedBytecode) {
        if (deployedBytecode === void 0) { deployedBytecode = DevUtilsContract.deployedBytecode; }
        var _this = _super.call(this, 'DevUtils', DevUtilsContract.ABI(), address, supportedProvider, txDefaults, logDecodeDependencies, deployedBytecode) || this;
        _this._methodABIIndex = {};
        utils_1.classUtils.bindAll(_this, ['_abiEncoderByFunctionSignature', 'address', '_web3Wrapper']);
        DevUtilsContract.ABI().forEach(function (item, index) {
            if (item.type === 'function') {
                var methodAbi = item;
                _this._methodABIIndex[methodAbi.name] = index;
            }
        });
        return _this;
    }
    DevUtilsContract.deployFrom0xArtifactAsync = function (artifact, supportedProvider, txDefaults, logDecodeDependencies, _exchange) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, _a, provider, bytecode, abi, logDecodeDependenciesAbiOnly, _b, _c, key;
            return __generator(this, function (_d) {
                assert_1.assert.doesConformToSchema('txDefaults', txDefaults, json_schemas_1.schemas.txDataSchema, [
                    json_schemas_1.schemas.addressSchema,
                    json_schemas_1.schemas.numberSchema,
                    json_schemas_1.schemas.jsNumber,
                ]);
                if (artifact.compilerOutput === undefined) {
                    throw new Error('Compiler output not found in the artifact file');
                }
                provider = utils_1.providerUtils.standardizeOrThrow(supportedProvider);
                bytecode = artifact.compilerOutput.evm.bytecode.object;
                abi = artifact.compilerOutput.abi;
                logDecodeDependenciesAbiOnly = {};
                if (Object.keys(logDecodeDependencies) !== undefined) {
                    try {
                        for (_b = __values(Object.keys(logDecodeDependencies)), _c = _b.next(); !_c.done; _c = _b.next()) {
                            key = _c.value;
                            logDecodeDependenciesAbiOnly[key] = logDecodeDependencies[key].compilerOutput.abi;
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                return [2 /*return*/, DevUtilsContract.deployAsync(bytecode, abi, provider, txDefaults, logDecodeDependenciesAbiOnly, _exchange)];
            });
        });
    };
    DevUtilsContract.deployAsync = function (bytecode, abi, supportedProvider, txDefaults, logDecodeDependencies, _exchange) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, provider, constructorAbi, iface, deployInfo, txData, web3Wrapper, txDataWithDefaults, txHash, txReceipt, contractInstance;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        assert_1.assert.isHexString('bytecode', bytecode);
                        assert_1.assert.doesConformToSchema('txDefaults', txDefaults, json_schemas_1.schemas.txDataSchema, [
                            json_schemas_1.schemas.addressSchema,
                            json_schemas_1.schemas.numberSchema,
                            json_schemas_1.schemas.jsNumber,
                        ]);
                        provider = utils_1.providerUtils.standardizeOrThrow(supportedProvider);
                        constructorAbi = base_contract_1.BaseContract._lookupConstructorAbi(abi);
                        _a = __read(base_contract_1.BaseContract._formatABIDataItemList(constructorAbi.inputs, [_exchange], base_contract_1.BaseContract._bigNumberToString), 1), _exchange = _a[0];
                        iface = new ethers.utils.Interface(abi);
                        deployInfo = iface.deployFunction;
                        txData = deployInfo.encode(bytecode, [_exchange]);
                        web3Wrapper = new web3_wrapper_1.Web3Wrapper(provider);
                        return [4 /*yield*/, base_contract_1.BaseContract._applyDefaultsToContractTxDataAsync(__assign({ data: txData }, txDefaults), web3Wrapper.estimateGasAsync.bind(web3Wrapper))];
                    case 1:
                        txDataWithDefaults = _b.sent();
                        return [4 /*yield*/, web3Wrapper.sendTransactionAsync(txDataWithDefaults)];
                    case 2:
                        txHash = _b.sent();
                        utils_1.logUtils.log("transactionHash: " + txHash);
                        return [4 /*yield*/, web3Wrapper.awaitTransactionSuccessAsync(txHash)];
                    case 3:
                        txReceipt = _b.sent();
                        utils_1.logUtils.log("DevUtils successfully deployed at " + txReceipt.contractAddress);
                        contractInstance = new DevUtilsContract(txReceipt.contractAddress, provider, txDefaults, logDecodeDependencies);
                        contractInstance.constructorArgs = [_exchange];
                        return [2 /*return*/, contractInstance];
                }
            });
        });
    };
    /**
     * @returns      The contract ABI
     */
    DevUtilsContract.ABI = function () {
        var abi = [
            {
                inputs: [
                    {
                        name: '_exchange',
                        type: 'address',
                    },
                ],
                outputs: [],
                payable: false,
                stateMutability: 'nonpayable',
                type: 'constructor',
            },
            {
                constant: true,
                inputs: [],
                name: 'EIP712_EXCHANGE_DOMAIN_HASH',
                outputs: [
                    {
                        name: '',
                        type: 'bytes32',
                    },
                ],
                payable: false,
                stateMutability: 'view',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'encoded',
                        type: 'bytes',
                    },
                ],
                name: 'decodeAssetProxyDispatchError',
                outputs: [
                    {
                        name: 'errorCode',
                        type: 'uint8',
                    },
                    {
                        name: 'orderHash',
                        type: 'bytes32',
                    },
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'encoded',
                        type: 'bytes',
                    },
                ],
                name: 'decodeAssetProxyExistsError',
                outputs: [
                    {
                        name: 'assetProxyId',
                        type: 'bytes4',
                    },
                    {
                        name: 'assetProxyAddress',
                        type: 'address',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                name: 'decodeAssetProxyId',
                outputs: [
                    {
                        name: 'assetProxyId',
                        type: 'bytes4',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'encoded',
                        type: 'bytes',
                    },
                ],
                name: 'decodeAssetProxyTransferError',
                outputs: [
                    {
                        name: 'orderHash',
                        type: 'bytes32',
                    },
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                    {
                        name: 'errorData',
                        type: 'bytes',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'encoded',
                        type: 'bytes',
                    },
                ],
                name: 'decodeEIP1271SignatureError',
                outputs: [
                    {
                        name: 'verifyingContractAddress',
                        type: 'address',
                    },
                    {
                        name: 'data',
                        type: 'bytes',
                    },
                    {
                        name: 'signature',
                        type: 'bytes',
                    },
                    {
                        name: 'errorData',
                        type: 'bytes',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                name: 'decodeERC1155AssetData',
                outputs: [
                    {
                        name: 'assetProxyId',
                        type: 'bytes4',
                    },
                    {
                        name: 'tokenAddress',
                        type: 'address',
                    },
                    {
                        name: 'tokenIds',
                        type: 'uint256[]',
                    },
                    {
                        name: 'tokenValues',
                        type: 'uint256[]',
                    },
                    {
                        name: 'callbackData',
                        type: 'bytes',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                name: 'decodeERC20AssetData',
                outputs: [
                    {
                        name: 'assetProxyId',
                        type: 'bytes4',
                    },
                    {
                        name: 'tokenAddress',
                        type: 'address',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                name: 'decodeERC721AssetData',
                outputs: [
                    {
                        name: 'assetProxyId',
                        type: 'bytes4',
                    },
                    {
                        name: 'tokenAddress',
                        type: 'address',
                    },
                    {
                        name: 'tokenId',
                        type: 'uint256',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'encoded',
                        type: 'bytes',
                    },
                ],
                name: 'decodeExchangeInvalidContextError',
                outputs: [
                    {
                        name: 'errorCode',
                        type: 'uint8',
                    },
                    {
                        name: 'orderHash',
                        type: 'bytes32',
                    },
                    {
                        name: 'contextAddress',
                        type: 'address',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'encoded',
                        type: 'bytes',
                    },
                ],
                name: 'decodeFillError',
                outputs: [
                    {
                        name: 'errorCode',
                        type: 'uint8',
                    },
                    {
                        name: 'orderHash',
                        type: 'bytes32',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'encoded',
                        type: 'bytes',
                    },
                ],
                name: 'decodeIncompleteFillError',
                outputs: [
                    {
                        name: 'errorCode',
                        type: 'uint8',
                    },
                    {
                        name: 'expectedAssetFillAmount',
                        type: 'uint256',
                    },
                    {
                        name: 'actualAssetFillAmount',
                        type: 'uint256',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                name: 'decodeMultiAssetData',
                outputs: [
                    {
                        name: 'assetProxyId',
                        type: 'bytes4',
                    },
                    {
                        name: 'amounts',
                        type: 'uint256[]',
                    },
                    {
                        name: 'nestedAssetData',
                        type: 'bytes[]',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'encoded',
                        type: 'bytes',
                    },
                ],
                name: 'decodeNegativeSpreadError',
                outputs: [
                    {
                        name: 'leftOrderHash',
                        type: 'bytes32',
                    },
                    {
                        name: 'rightOrderHash',
                        type: 'bytes32',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'encoded',
                        type: 'bytes',
                    },
                ],
                name: 'decodeOrderEpochError',
                outputs: [
                    {
                        name: 'makerAddress',
                        type: 'address',
                    },
                    {
                        name: 'orderSenderAddress',
                        type: 'address',
                    },
                    {
                        name: 'currentEpoch',
                        type: 'uint256',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'encoded',
                        type: 'bytes',
                    },
                ],
                name: 'decodeOrderStatusError',
                outputs: [
                    {
                        name: 'orderHash',
                        type: 'bytes32',
                    },
                    {
                        name: 'orderStatus',
                        type: 'uint8',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'encoded',
                        type: 'bytes',
                    },
                ],
                name: 'decodeSignatureError',
                outputs: [
                    {
                        name: 'errorCode',
                        type: 'uint8',
                    },
                    {
                        name: 'hash',
                        type: 'bytes32',
                    },
                    {
                        name: 'signerAddress',
                        type: 'address',
                    },
                    {
                        name: 'signature',
                        type: 'bytes',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'encoded',
                        type: 'bytes',
                    },
                ],
                name: 'decodeSignatureValidatorNotApprovedError',
                outputs: [
                    {
                        name: 'signerAddress',
                        type: 'address',
                    },
                    {
                        name: 'validatorAddress',
                        type: 'address',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'encoded',
                        type: 'bytes',
                    },
                ],
                name: 'decodeSignatureWalletError',
                outputs: [
                    {
                        name: 'hash',
                        type: 'bytes32',
                    },
                    {
                        name: 'signerAddress',
                        type: 'address',
                    },
                    {
                        name: 'signature',
                        type: 'bytes',
                    },
                    {
                        name: 'errorData',
                        type: 'bytes',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                name: 'decodeStaticCallAssetData',
                outputs: [
                    {
                        name: 'assetProxyId',
                        type: 'bytes4',
                    },
                    {
                        name: 'staticCallTargetAddress',
                        type: 'address',
                    },
                    {
                        name: 'staticCallData',
                        type: 'bytes',
                    },
                    {
                        name: 'expectedReturnDataHash',
                        type: 'bytes32',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'encoded',
                        type: 'bytes',
                    },
                ],
                name: 'decodeTransactionError',
                outputs: [
                    {
                        name: 'errorCode',
                        type: 'uint8',
                    },
                    {
                        name: 'transactionHash',
                        type: 'bytes32',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'encoded',
                        type: 'bytes',
                    },
                ],
                name: 'decodeTransactionExecutionError',
                outputs: [
                    {
                        name: 'transactionHash',
                        type: 'bytes32',
                    },
                    {
                        name: 'errorData',
                        type: 'bytes',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'transactionData',
                        type: 'bytes',
                    },
                ],
                name: 'decodeZeroExTransactionData',
                outputs: [
                    {
                        name: 'functionName',
                        type: 'string',
                    },
                    {
                        name: 'orders',
                        type: 'tuple[]',
                        components: [
                            {
                                name: 'makerAddress',
                                type: 'address',
                            },
                            {
                                name: 'takerAddress',
                                type: 'address',
                            },
                            {
                                name: 'feeRecipientAddress',
                                type: 'address',
                            },
                            {
                                name: 'senderAddress',
                                type: 'address',
                            },
                            {
                                name: 'makerAssetAmount',
                                type: 'uint256',
                            },
                            {
                                name: 'takerAssetAmount',
                                type: 'uint256',
                            },
                            {
                                name: 'makerFee',
                                type: 'uint256',
                            },
                            {
                                name: 'takerFee',
                                type: 'uint256',
                            },
                            {
                                name: 'expirationTimeSeconds',
                                type: 'uint256',
                            },
                            {
                                name: 'salt',
                                type: 'uint256',
                            },
                            {
                                name: 'makerAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'takerAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'makerFeeAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'takerFeeAssetData',
                                type: 'bytes',
                            },
                        ],
                    },
                    {
                        name: 'takerAssetFillAmounts',
                        type: 'uint256[]',
                    },
                    {
                        name: 'signatures',
                        type: 'bytes[]',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'tokenAddress',
                        type: 'address',
                    },
                    {
                        name: 'tokenIds',
                        type: 'uint256[]',
                    },
                    {
                        name: 'tokenValues',
                        type: 'uint256[]',
                    },
                    {
                        name: 'callbackData',
                        type: 'bytes',
                    },
                ],
                name: 'encodeERC1155AssetData',
                outputs: [
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'tokenAddress',
                        type: 'address',
                    },
                ],
                name: 'encodeERC20AssetData',
                outputs: [
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'tokenAddress',
                        type: 'address',
                    },
                    {
                        name: 'tokenId',
                        type: 'uint256',
                    },
                ],
                name: 'encodeERC721AssetData',
                outputs: [
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'amounts',
                        type: 'uint256[]',
                    },
                    {
                        name: 'nestedAssetData',
                        type: 'bytes[]',
                    },
                ],
                name: 'encodeMultiAssetData',
                outputs: [
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'staticCallTargetAddress',
                        type: 'address',
                    },
                    {
                        name: 'staticCallData',
                        type: 'bytes',
                    },
                    {
                        name: 'expectedReturnDataHash',
                        type: 'bytes32',
                    },
                ],
                name: 'encodeStaticCallAssetData',
                outputs: [
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'ownerAddress',
                        type: 'address',
                    },
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                name: 'getAssetProxyAllowance',
                outputs: [
                    {
                        name: 'allowance',
                        type: 'uint256',
                    },
                ],
                payable: false,
                stateMutability: 'view',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'ownerAddress',
                        type: 'address',
                    },
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                name: 'getBalance',
                outputs: [
                    {
                        name: 'balance',
                        type: 'uint256',
                    },
                ],
                payable: false,
                stateMutability: 'view',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'ownerAddress',
                        type: 'address',
                    },
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                name: 'getBalanceAndAssetProxyAllowance',
                outputs: [
                    {
                        name: 'balance',
                        type: 'uint256',
                    },
                    {
                        name: 'allowance',
                        type: 'uint256',
                    },
                ],
                payable: false,
                stateMutability: 'view',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'ownerAddress',
                        type: 'address',
                    },
                    {
                        name: 'assetData',
                        type: 'bytes[]',
                    },
                ],
                name: 'getBatchAssetProxyAllowances',
                outputs: [
                    {
                        name: 'allowances',
                        type: 'uint256[]',
                    },
                ],
                payable: false,
                stateMutability: 'view',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'ownerAddress',
                        type: 'address',
                    },
                    {
                        name: 'assetData',
                        type: 'bytes[]',
                    },
                ],
                name: 'getBatchBalances',
                outputs: [
                    {
                        name: 'balances',
                        type: 'uint256[]',
                    },
                ],
                payable: false,
                stateMutability: 'view',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'ownerAddress',
                        type: 'address',
                    },
                    {
                        name: 'assetData',
                        type: 'bytes[]',
                    },
                ],
                name: 'getBatchBalancesAndAssetProxyAllowances',
                outputs: [
                    {
                        name: 'balances',
                        type: 'uint256[]',
                    },
                    {
                        name: 'allowances',
                        type: 'uint256[]',
                    },
                ],
                payable: false,
                stateMutability: 'view',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'addresses',
                        type: 'address[]',
                    },
                ],
                name: 'getEthBalances',
                outputs: [
                    {
                        name: '',
                        type: 'uint256[]',
                    },
                ],
                payable: false,
                stateMutability: 'view',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'order',
                        type: 'tuple',
                        components: [
                            {
                                name: 'makerAddress',
                                type: 'address',
                            },
                            {
                                name: 'takerAddress',
                                type: 'address',
                            },
                            {
                                name: 'feeRecipientAddress',
                                type: 'address',
                            },
                            {
                                name: 'senderAddress',
                                type: 'address',
                            },
                            {
                                name: 'makerAssetAmount',
                                type: 'uint256',
                            },
                            {
                                name: 'takerAssetAmount',
                                type: 'uint256',
                            },
                            {
                                name: 'makerFee',
                                type: 'uint256',
                            },
                            {
                                name: 'takerFee',
                                type: 'uint256',
                            },
                            {
                                name: 'expirationTimeSeconds',
                                type: 'uint256',
                            },
                            {
                                name: 'salt',
                                type: 'uint256',
                            },
                            {
                                name: 'makerAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'takerAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'makerFeeAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'takerFeeAssetData',
                                type: 'bytes',
                            },
                        ],
                    },
                    {
                        name: 'chainId',
                        type: 'uint256',
                    },
                    {
                        name: 'exchange',
                        type: 'address',
                    },
                ],
                name: 'getOrderHash',
                outputs: [
                    {
                        name: 'orderHash',
                        type: 'bytes32',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'order',
                        type: 'tuple',
                        components: [
                            {
                                name: 'makerAddress',
                                type: 'address',
                            },
                            {
                                name: 'takerAddress',
                                type: 'address',
                            },
                            {
                                name: 'feeRecipientAddress',
                                type: 'address',
                            },
                            {
                                name: 'senderAddress',
                                type: 'address',
                            },
                            {
                                name: 'makerAssetAmount',
                                type: 'uint256',
                            },
                            {
                                name: 'takerAssetAmount',
                                type: 'uint256',
                            },
                            {
                                name: 'makerFee',
                                type: 'uint256',
                            },
                            {
                                name: 'takerFee',
                                type: 'uint256',
                            },
                            {
                                name: 'expirationTimeSeconds',
                                type: 'uint256',
                            },
                            {
                                name: 'salt',
                                type: 'uint256',
                            },
                            {
                                name: 'makerAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'takerAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'makerFeeAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'takerFeeAssetData',
                                type: 'bytes',
                            },
                        ],
                    },
                    {
                        name: 'signature',
                        type: 'bytes',
                    },
                ],
                name: 'getOrderRelevantState',
                outputs: [
                    {
                        name: 'orderInfo',
                        type: 'tuple',
                        components: [
                            {
                                name: 'orderStatus',
                                type: 'uint8',
                            },
                            {
                                name: 'orderHash',
                                type: 'bytes32',
                            },
                            {
                                name: 'orderTakerAssetFilledAmount',
                                type: 'uint256',
                            },
                        ],
                    },
                    {
                        name: 'fillableTakerAssetAmount',
                        type: 'uint256',
                    },
                    {
                        name: 'isValidSignature',
                        type: 'bool',
                    },
                ],
                payable: false,
                stateMutability: 'view',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'orders',
                        type: 'tuple[]',
                        components: [
                            {
                                name: 'makerAddress',
                                type: 'address',
                            },
                            {
                                name: 'takerAddress',
                                type: 'address',
                            },
                            {
                                name: 'feeRecipientAddress',
                                type: 'address',
                            },
                            {
                                name: 'senderAddress',
                                type: 'address',
                            },
                            {
                                name: 'makerAssetAmount',
                                type: 'uint256',
                            },
                            {
                                name: 'takerAssetAmount',
                                type: 'uint256',
                            },
                            {
                                name: 'makerFee',
                                type: 'uint256',
                            },
                            {
                                name: 'takerFee',
                                type: 'uint256',
                            },
                            {
                                name: 'expirationTimeSeconds',
                                type: 'uint256',
                            },
                            {
                                name: 'salt',
                                type: 'uint256',
                            },
                            {
                                name: 'makerAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'takerAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'makerFeeAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'takerFeeAssetData',
                                type: 'bytes',
                            },
                        ],
                    },
                    {
                        name: 'signatures',
                        type: 'bytes[]',
                    },
                ],
                name: 'getOrderRelevantStates',
                outputs: [
                    {
                        name: 'ordersInfo',
                        type: 'tuple[]',
                        components: [
                            {
                                name: 'orderStatus',
                                type: 'uint8',
                            },
                            {
                                name: 'orderHash',
                                type: 'bytes32',
                            },
                            {
                                name: 'orderTakerAssetFilledAmount',
                                type: 'uint256',
                            },
                        ],
                    },
                    {
                        name: 'fillableTakerAssetAmounts',
                        type: 'uint256[]',
                    },
                    {
                        name: 'isValidSignature',
                        type: 'bool[]',
                    },
                ],
                payable: false,
                stateMutability: 'view',
                type: 'function',
            },
            {
                constant: false,
                inputs: [
                    {
                        name: 'order',
                        type: 'tuple',
                        components: [
                            {
                                name: 'makerAddress',
                                type: 'address',
                            },
                            {
                                name: 'takerAddress',
                                type: 'address',
                            },
                            {
                                name: 'feeRecipientAddress',
                                type: 'address',
                            },
                            {
                                name: 'senderAddress',
                                type: 'address',
                            },
                            {
                                name: 'makerAssetAmount',
                                type: 'uint256',
                            },
                            {
                                name: 'takerAssetAmount',
                                type: 'uint256',
                            },
                            {
                                name: 'makerFee',
                                type: 'uint256',
                            },
                            {
                                name: 'takerFee',
                                type: 'uint256',
                            },
                            {
                                name: 'expirationTimeSeconds',
                                type: 'uint256',
                            },
                            {
                                name: 'salt',
                                type: 'uint256',
                            },
                            {
                                name: 'makerAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'takerAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'makerFeeAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'takerFeeAssetData',
                                type: 'bytes',
                            },
                        ],
                    },
                    {
                        name: 'takerAddress',
                        type: 'address',
                    },
                    {
                        name: 'takerAssetFillAmount',
                        type: 'uint256',
                    },
                ],
                name: 'getSimulatedOrderTransferResults',
                outputs: [
                    {
                        name: 'orderTransferResults',
                        type: 'uint8',
                    },
                ],
                payable: false,
                stateMutability: 'nonpayable',
                type: 'function',
            },
            {
                constant: false,
                inputs: [
                    {
                        name: 'orders',
                        type: 'tuple[]',
                        components: [
                            {
                                name: 'makerAddress',
                                type: 'address',
                            },
                            {
                                name: 'takerAddress',
                                type: 'address',
                            },
                            {
                                name: 'feeRecipientAddress',
                                type: 'address',
                            },
                            {
                                name: 'senderAddress',
                                type: 'address',
                            },
                            {
                                name: 'makerAssetAmount',
                                type: 'uint256',
                            },
                            {
                                name: 'takerAssetAmount',
                                type: 'uint256',
                            },
                            {
                                name: 'makerFee',
                                type: 'uint256',
                            },
                            {
                                name: 'takerFee',
                                type: 'uint256',
                            },
                            {
                                name: 'expirationTimeSeconds',
                                type: 'uint256',
                            },
                            {
                                name: 'salt',
                                type: 'uint256',
                            },
                            {
                                name: 'makerAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'takerAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'makerFeeAssetData',
                                type: 'bytes',
                            },
                            {
                                name: 'takerFeeAssetData',
                                type: 'bytes',
                            },
                        ],
                    },
                    {
                        name: 'takerAddresses',
                        type: 'address[]',
                    },
                    {
                        name: 'takerAssetFillAmounts',
                        type: 'uint256[]',
                    },
                ],
                name: 'getSimulatedOrdersTransferResults',
                outputs: [
                    {
                        name: 'orderTransferResults',
                        type: 'uint8[]',
                    },
                ],
                payable: false,
                stateMutability: 'nonpayable',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'transaction',
                        type: 'tuple',
                        components: [
                            {
                                name: 'salt',
                                type: 'uint256',
                            },
                            {
                                name: 'expirationTimeSeconds',
                                type: 'uint256',
                            },
                            {
                                name: 'gasPrice',
                                type: 'uint256',
                            },
                            {
                                name: 'signerAddress',
                                type: 'address',
                            },
                            {
                                name: 'data',
                                type: 'bytes',
                            },
                        ],
                    },
                    {
                        name: 'chainId',
                        type: 'uint256',
                    },
                    {
                        name: 'exchange',
                        type: 'address',
                    },
                ],
                name: 'getTransactionHash',
                outputs: [
                    {
                        name: 'transactionHash',
                        type: 'bytes32',
                    },
                ],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'ownerAddress',
                        type: 'address',
                    },
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                name: 'getTransferableAssetAmount',
                outputs: [
                    {
                        name: 'transferableAssetAmount',
                        type: 'uint256',
                    },
                ],
                payable: false,
                stateMutability: 'view',
                type: 'function',
            },
            {
                constant: true,
                inputs: [
                    {
                        name: 'assetData',
                        type: 'bytes',
                    },
                ],
                name: 'revertIfInvalidAssetData',
                outputs: [],
                payable: false,
                stateMutability: 'pure',
                type: 'function',
            },
        ];
        return abi;
    };
    DevUtilsContract.prototype.getFunctionSignature = function (methodName) {
        var index = this._methodABIIndex[methodName];
        var methodAbi = DevUtilsContract.ABI()[index]; // tslint:disable-line:no-unnecessary-type-assertion
        var functionSignature = base_contract_1.methodAbiToFunctionSignature(methodAbi);
        return functionSignature;
    };
    DevUtilsContract.prototype.getABIDecodedTransactionData = function (methodName, callData) {
        var functionSignature = this.getFunctionSignature(methodName);
        var self = this;
        var abiEncoder = self._lookupAbiEncoder(functionSignature);
        var abiDecodedCallData = abiEncoder.strictDecode(callData);
        return abiDecodedCallData;
    };
    DevUtilsContract.prototype.getABIDecodedReturnData = function (methodName, callData) {
        var functionSignature = this.getFunctionSignature(methodName);
        var self = this;
        var abiEncoder = self._lookupAbiEncoder(functionSignature);
        var abiDecodedCallData = abiEncoder.strictDecodeReturnValue(callData);
        return abiDecodedCallData;
    };
    DevUtilsContract.prototype.getSelector = function (methodName) {
        var functionSignature = this.getFunctionSignature(methodName);
        var self = this;
        var abiEncoder = self._lookupAbiEncoder(functionSignature);
        return abiEncoder.getSelector();
    };
    DevUtilsContract.prototype.EIP712_EXCHANGE_DOMAIN_HASH = function () {
        var self = this;
        var functionSignature = 'EIP712_EXCHANGE_DOMAIN_HASH()';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._performCallAsync(__assign({}, callData, { data: this.getABIEncodedTransactionData() }), defaultBlock)];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, []);
            },
        };
    };
    /**
     * Decompose an ABI-encoded AssetProxyDispatchError.
     * @param encoded ABI-encoded revert error.
     * @returns errorCode The error code.orderHash Hash of the order being dispatched.assetData Asset data of the order being dispatched.
     */
    DevUtilsContract.prototype.decodeAssetProxyDispatchError = function (encoded) {
        var self = this;
        assert_1.assert.isString('encoded', encoded);
        var functionSignature = 'decodeAssetProxyDispatchError(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [encoded]);
            },
        };
    };
    /**
     * Decompose an ABI-encoded AssetProxyExistsError.
     * @param encoded ABI-encoded revert error.
     * @returns assetProxyId Id of asset proxy.assetProxyAddress The address of the asset proxy.
     */
    DevUtilsContract.prototype.decodeAssetProxyExistsError = function (encoded) {
        var self = this;
        assert_1.assert.isString('encoded', encoded);
        var functionSignature = 'decodeAssetProxyExistsError(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [encoded]);
            },
        };
    };
    /**
     * Decode AssetProxy identifier
     * @param assetData AssetProxy-compliant asset data describing an ERC-20, ERC-
     *     721, ERC1155, or MultiAsset asset.
     * @returns The AssetProxy identifier
     */
    DevUtilsContract.prototype.decodeAssetProxyId = function (assetData) {
        var self = this;
        assert_1.assert.isString('assetData', assetData);
        var functionSignature = 'decodeAssetProxyId(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [assetData]);
            },
        };
    };
    /**
     * Decompose an ABI-encoded AssetProxyTransferError.
     * @param encoded ABI-encoded revert error.
     * @returns orderHash Hash of the order being dispatched.assetData Asset data of the order being dispatched.errorData ABI-encoded revert data from the asset proxy.
     */
    DevUtilsContract.prototype.decodeAssetProxyTransferError = function (encoded) {
        var self = this;
        assert_1.assert.isString('encoded', encoded);
        var functionSignature = 'decodeAssetProxyTransferError(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [encoded]);
            },
        };
    };
    /**
     * Decompose an ABI-encoded SignatureValidatorError.
     * @param encoded ABI-encoded revert error.
     * @returns signerAddress The expected signer of the hash.signature The full signature bytes.errorData The revert data thrown by the validator contract.
     */
    DevUtilsContract.prototype.decodeEIP1271SignatureError = function (encoded) {
        var self = this;
        assert_1.assert.isString('encoded', encoded);
        var functionSignature = 'decodeEIP1271SignatureError(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [encoded]);
            },
        };
    };
    /**
     * Decode ERC-1155 asset data from the format described in the AssetProxy contract specification.
     * @param assetData AssetProxy-compliant asset data describing an ERC-1155 set
     *     of assets.
     * @returns The ERC-1155 AssetProxy identifier, the address of the ERC-1155 contract hosting the assets, an array of the identifiers of the assets to be traded, an array of asset amounts to be traded, and callback data.  Each element of the arrays corresponds to the same-indexed element of the other array.  Return values specified as &#x60;memory&#x60; are returned as pointers to locations within the memory of the input parameter &#x60;assetData&#x60;.
     */
    DevUtilsContract.prototype.decodeERC1155AssetData = function (assetData) {
        var self = this;
        assert_1.assert.isString('assetData', assetData);
        var functionSignature = 'decodeERC1155AssetData(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [assetData]);
            },
        };
    };
    /**
     * Decode ERC-20 asset data from the format described in the AssetProxy contract specification.
     * @param assetData AssetProxy-compliant asset data describing an ERC-20 asset.
     * @returns The AssetProxy identifier, and the address of the ERC-20  contract hosting this asset.
     */
    DevUtilsContract.prototype.decodeERC20AssetData = function (assetData) {
        var self = this;
        assert_1.assert.isString('assetData', assetData);
        var functionSignature = 'decodeERC20AssetData(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [assetData]);
            },
        };
    };
    /**
     * Decode ERC-721 asset data from the format described in the AssetProxy contract specification.
     * @param assetData AssetProxy-compliant asset data describing an ERC-721
     *     asset.
     * @returns The ERC-721 AssetProxy identifier, the address of the ERC-721 contract hosting this asset, and the identifier of the specific asset to be traded.
     */
    DevUtilsContract.prototype.decodeERC721AssetData = function (assetData) {
        var self = this;
        assert_1.assert.isString('assetData', assetData);
        var functionSignature = 'decodeERC721AssetData(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [assetData]);
            },
        };
    };
    /**
     * Decompose an ABI-encoded OrderStatusError.
     * @param encoded ABI-encoded revert error.
     * @returns errorCode Error code that corresponds to invalid maker, taker, or sender.orderHash The order hash.contextAddress The maker, taker, or sender address
     */
    DevUtilsContract.prototype.decodeExchangeInvalidContextError = function (encoded) {
        var self = this;
        assert_1.assert.isString('encoded', encoded);
        var functionSignature = 'decodeExchangeInvalidContextError(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [encoded]);
            },
        };
    };
    /**
     * Decompose an ABI-encoded FillError.
     * @param encoded ABI-encoded revert error.
     * @returns errorCode The error code.orderHash The order hash.
     */
    DevUtilsContract.prototype.decodeFillError = function (encoded) {
        var self = this;
        assert_1.assert.isString('encoded', encoded);
        var functionSignature = 'decodeFillError(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [encoded]);
            },
        };
    };
    /**
     * Decompose an ABI-encoded IncompleteFillError.
     * @param encoded ABI-encoded revert error.
     * @returns orderHash Hash of the order being filled.
     */
    DevUtilsContract.prototype.decodeIncompleteFillError = function (encoded) {
        var self = this;
        assert_1.assert.isString('encoded', encoded);
        var functionSignature = 'decodeIncompleteFillError(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [encoded]);
            },
        };
    };
    /**
     * Decode multi-asset data from the format described in the AssetProxy contract specification.
     * @param assetData AssetProxy-compliant data describing a multi-asset basket.
     * @returns The Multi-Asset AssetProxy identifier, an array of the amounts of the assets to be traded, and an array of the AssetProxy-compliant data describing each asset to be traded.  Each element of the arrays corresponds to the same-indexed element of the other array.
     */
    DevUtilsContract.prototype.decodeMultiAssetData = function (assetData) {
        var self = this;
        assert_1.assert.isString('assetData', assetData);
        var functionSignature = 'decodeMultiAssetData(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [assetData]);
            },
        };
    };
    /**
     * Decompose an ABI-encoded NegativeSpreadError.
     * @param encoded ABI-encoded revert error.
     * @returns leftOrderHash Hash of the left order being matched.rightOrderHash Hash of the right order being matched.
     */
    DevUtilsContract.prototype.decodeNegativeSpreadError = function (encoded) {
        var self = this;
        assert_1.assert.isString('encoded', encoded);
        var functionSignature = 'decodeNegativeSpreadError(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [encoded]);
            },
        };
    };
    /**
     * Decompose an ABI-encoded OrderEpochError.
     * @param encoded ABI-encoded revert error.
     * @returns makerAddress The order maker.orderSenderAddress The order sender.currentEpoch The current epoch for the maker.
     */
    DevUtilsContract.prototype.decodeOrderEpochError = function (encoded) {
        var self = this;
        assert_1.assert.isString('encoded', encoded);
        var functionSignature = 'decodeOrderEpochError(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [encoded]);
            },
        };
    };
    /**
     * Decompose an ABI-encoded OrderStatusError.
     * @param encoded ABI-encoded revert error.
     * @returns orderHash The order hash.orderStatus The order status.
     */
    DevUtilsContract.prototype.decodeOrderStatusError = function (encoded) {
        var self = this;
        assert_1.assert.isString('encoded', encoded);
        var functionSignature = 'decodeOrderStatusError(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [encoded]);
            },
        };
    };
    /**
     * Decompose an ABI-encoded SignatureError.
     * @param encoded ABI-encoded revert error.
     * @returns errorCode The error code.signerAddress The expected signer of the hash.signature The full signature.
     */
    DevUtilsContract.prototype.decodeSignatureError = function (encoded) {
        var self = this;
        assert_1.assert.isString('encoded', encoded);
        var functionSignature = 'decodeSignatureError(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [encoded]);
            },
        };
    };
    /**
     * Decompose an ABI-encoded SignatureValidatorNotApprovedError.
     * @param encoded ABI-encoded revert error.
     * @returns signerAddress The expected signer of the hash.validatorAddress The expected validator.
     */
    DevUtilsContract.prototype.decodeSignatureValidatorNotApprovedError = function (encoded) {
        var self = this;
        assert_1.assert.isString('encoded', encoded);
        var functionSignature = 'decodeSignatureValidatorNotApprovedError(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [encoded]);
            },
        };
    };
    /**
     * Decompose an ABI-encoded SignatureWalletError.
     * @param encoded ABI-encoded revert error.
     * @returns errorCode The error code.signerAddress The expected signer of the hash.signature The full signature bytes.errorData The revert data thrown by the validator contract.
     */
    DevUtilsContract.prototype.decodeSignatureWalletError = function (encoded) {
        var self = this;
        assert_1.assert.isString('encoded', encoded);
        var functionSignature = 'decodeSignatureWalletError(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [encoded]);
            },
        };
    };
    /**
     * Decode StaticCall asset data from the format described in the AssetProxy contract specification.
     * @param assetData AssetProxy-compliant asset data describing a StaticCall
     *     asset
     * @returns The StaticCall AssetProxy identifier, the target address of the StaticCAll, the data to be passed to the target address, and the expected Keccak-256 hash of the static call return data.
     */
    DevUtilsContract.prototype.decodeStaticCallAssetData = function (assetData) {
        var self = this;
        assert_1.assert.isString('assetData', assetData);
        var functionSignature = 'decodeStaticCallAssetData(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [assetData]);
            },
        };
    };
    /**
     * Decompose an ABI-encoded TransactionError.
     * @param encoded ABI-encoded revert error.
     * @returns errorCode The error code.transactionHash Hash of the transaction.
     */
    DevUtilsContract.prototype.decodeTransactionError = function (encoded) {
        var self = this;
        assert_1.assert.isString('encoded', encoded);
        var functionSignature = 'decodeTransactionError(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [encoded]);
            },
        };
    };
    /**
     * Decompose an ABI-encoded TransactionExecutionError.
     * @param encoded ABI-encoded revert error.
     * @returns transactionHash Hash of the transaction.errorData Error thrown by exeucteTransaction().
     */
    DevUtilsContract.prototype.decodeTransactionExecutionError = function (encoded) {
        var self = this;
        assert_1.assert.isString('encoded', encoded);
        var functionSignature = 'decodeTransactionExecutionError(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [encoded]);
            },
        };
    };
    /**
     * Decodes the call data for an Exchange contract method call.
     * @param transactionData ABI-encoded calldata for an Exchange     contract
     *     method call.
     * @returns The name of the function called, and the parameters it was     given.  For single-order fills and cancels, the arrays will have     just one element.
     */
    DevUtilsContract.prototype.decodeZeroExTransactionData = function (transactionData) {
        var self = this;
        assert_1.assert.isString('transactionData', transactionData);
        var functionSignature = 'decodeZeroExTransactionData(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [transactionData]);
            },
        };
    };
    /**
     * Encode ERC-1155 asset data into the format described in the AssetProxy contract specification.
     * @param tokenAddress The address of the ERC-1155 contract hosting the
     *     asset(s) to be traded.
     * @param tokenIds The identifiers of the specific assets to be traded.
     * @param tokenValues The amounts of each asset to be traded.
     * @param callbackData Data to be passed to receiving contracts when a transfer
     *     is performed.
     * @returns AssetProxy-compliant asset data describing the set of assets.
     */
    DevUtilsContract.prototype.encodeERC1155AssetData = function (tokenAddress, tokenIds, tokenValues, callbackData) {
        var self = this;
        assert_1.assert.isString('tokenAddress', tokenAddress);
        assert_1.assert.isArray('tokenIds', tokenIds);
        assert_1.assert.isArray('tokenValues', tokenValues);
        assert_1.assert.isString('callbackData', callbackData);
        var functionSignature = 'encodeERC1155AssetData(address,uint256[],uint256[],bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [
                    tokenAddress.toLowerCase(),
                    tokenIds,
                    tokenValues,
                    callbackData,
                ]);
            },
        };
    };
    /**
     * Encode ERC-20 asset data into the format described in the AssetProxy contract specification.
     * @param tokenAddress The address of the ERC-20 contract hosting the asset to
     *     be traded.
     * @returns AssetProxy-compliant data describing the asset.
     */
    DevUtilsContract.prototype.encodeERC20AssetData = function (tokenAddress) {
        var self = this;
        assert_1.assert.isString('tokenAddress', tokenAddress);
        var functionSignature = 'encodeERC20AssetData(address)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [tokenAddress.toLowerCase()]);
            },
        };
    };
    /**
     * Encode ERC-721 asset data into the format described in the AssetProxy specification.
     * @param tokenAddress The address of the ERC-721 contract hosting the asset to
     *     be traded.
     * @param tokenId The identifier of the specific asset to be traded.
     * @returns AssetProxy-compliant asset data describing the asset.
     */
    DevUtilsContract.prototype.encodeERC721AssetData = function (tokenAddress, tokenId) {
        var self = this;
        assert_1.assert.isString('tokenAddress', tokenAddress);
        assert_1.assert.isBigNumber('tokenId', tokenId);
        var functionSignature = 'encodeERC721AssetData(address,uint256)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [tokenAddress.toLowerCase(), tokenId]);
            },
        };
    };
    /**
     * Encode data for multiple assets, per the AssetProxy contract specification.
     * @param amounts The amounts of each asset to be traded.
     * @param nestedAssetData AssetProxy-compliant data describing each asset to be
     *     traded.
     * @returns AssetProxy-compliant data describing the set of assets.
     */
    DevUtilsContract.prototype.encodeMultiAssetData = function (amounts, nestedAssetData) {
        var self = this;
        assert_1.assert.isArray('amounts', amounts);
        assert_1.assert.isArray('nestedAssetData', nestedAssetData);
        var functionSignature = 'encodeMultiAssetData(uint256[],bytes[])';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [amounts, nestedAssetData]);
            },
        };
    };
    /**
     * Encode StaticCall asset data into the format described in the AssetProxy contract specification.
     * @param staticCallTargetAddress Target address of StaticCall.
     * @param staticCallData Data that will be passed to staticCallTargetAddress in
     *     the StaticCall.
     * @param expectedReturnDataHash Expected Keccak-256 hash of the StaticCall
     *     return data.
     * @returns AssetProxy-compliant asset data describing the set of assets.
     */
    DevUtilsContract.prototype.encodeStaticCallAssetData = function (staticCallTargetAddress, staticCallData, expectedReturnDataHash) {
        var self = this;
        assert_1.assert.isString('staticCallTargetAddress', staticCallTargetAddress);
        assert_1.assert.isString('staticCallData', staticCallData);
        assert_1.assert.isString('expectedReturnDataHash', expectedReturnDataHash);
        var functionSignature = 'encodeStaticCallAssetData(address,bytes,bytes32)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [
                    staticCallTargetAddress.toLowerCase(),
                    staticCallData,
                    expectedReturnDataHash,
                ]);
            },
        };
    };
    /**
     * Returns the number of asset(s) (described by assetData) that the corresponding AssetProxy contract is authorized to spend.  When the asset data contains multiple assets (eg for Multi-Asset), the return value indicates how many complete "baskets" of those assets may be spent by all of the corresponding AssetProxy contracts.
     * @param ownerAddress Owner of the assets specified by assetData.
     * @param assetData Details of asset, encoded per the AssetProxy contract
     *     specification.
     * @returns Number of assets (or asset baskets) that the corresponding AssetProxy is authorized to spend.
     */
    DevUtilsContract.prototype.getAssetProxyAllowance = function (ownerAddress, assetData) {
        var self = this;
        assert_1.assert.isString('ownerAddress', ownerAddress);
        assert_1.assert.isString('assetData', assetData);
        var functionSignature = 'getAssetProxyAllowance(address,bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._performCallAsync(__assign({}, callData, { data: this.getABIEncodedTransactionData() }), defaultBlock)];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [ownerAddress.toLowerCase(), assetData]);
            },
        };
    };
    /**
     * Returns the owner's balance of the assets(s) specified in assetData.  When the asset data contains multiple assets (eg in ERC1155 or Multi-Asset), the return value indicates how many complete "baskets" of those assets are owned by owner.
     * @param ownerAddress Owner of the assets specified by assetData.
     * @param assetData Details of asset, encoded per the AssetProxy contract
     *     specification.
     * @returns Number of assets (or asset baskets) held by owner.
     */
    DevUtilsContract.prototype.getBalance = function (ownerAddress, assetData) {
        var self = this;
        assert_1.assert.isString('ownerAddress', ownerAddress);
        assert_1.assert.isString('assetData', assetData);
        var functionSignature = 'getBalance(address,bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._performCallAsync(__assign({}, callData, { data: this.getABIEncodedTransactionData() }), defaultBlock)];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [ownerAddress.toLowerCase(), assetData]);
            },
        };
    };
    /**
     * Calls getBalance() and getAllowance() for assetData.
     * @param ownerAddress Owner of the assets specified by assetData.
     * @param assetData Details of asset, encoded per the AssetProxy contract
     *     specification.
     * @returns Number of assets (or asset baskets) held by owner, and number of assets (or asset baskets) that the corresponding AssetProxy is authorized to spend.
     */
    DevUtilsContract.prototype.getBalanceAndAssetProxyAllowance = function (ownerAddress, assetData) {
        var self = this;
        assert_1.assert.isString('ownerAddress', ownerAddress);
        assert_1.assert.isString('assetData', assetData);
        var functionSignature = 'getBalanceAndAssetProxyAllowance(address,bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._performCallAsync(__assign({}, callData, { data: this.getABIEncodedTransactionData() }), defaultBlock)];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [ownerAddress.toLowerCase(), assetData]);
            },
        };
    };
    /**
     * Calls getAssetProxyAllowance() for each element of assetData.
     * @param ownerAddress Owner of the assets specified by assetData.
     * @param assetData Array of asset details, each encoded per the AssetProxy
     *     contract specification.
     * @returns An array of asset allowances from getAllowance(), with each element corresponding to the same-indexed element in the assetData input.
     */
    DevUtilsContract.prototype.getBatchAssetProxyAllowances = function (ownerAddress, assetData) {
        var self = this;
        assert_1.assert.isString('ownerAddress', ownerAddress);
        assert_1.assert.isArray('assetData', assetData);
        var functionSignature = 'getBatchAssetProxyAllowances(address,bytes[])';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._performCallAsync(__assign({}, callData, { data: this.getABIEncodedTransactionData() }), defaultBlock)];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [ownerAddress.toLowerCase(), assetData]);
            },
        };
    };
    /**
     * Calls getBalance() for each element of assetData.
     * @param ownerAddress Owner of the assets specified by assetData.
     * @param assetData Array of asset details, each encoded per the AssetProxy
     *     contract specification.
     * @returns Array of asset balances from getBalance(), with each element corresponding to the same-indexed element in the assetData input.
     */
    DevUtilsContract.prototype.getBatchBalances = function (ownerAddress, assetData) {
        var self = this;
        assert_1.assert.isString('ownerAddress', ownerAddress);
        assert_1.assert.isArray('assetData', assetData);
        var functionSignature = 'getBatchBalances(address,bytes[])';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._performCallAsync(__assign({}, callData, { data: this.getABIEncodedTransactionData() }), defaultBlock)];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [ownerAddress.toLowerCase(), assetData]);
            },
        };
    };
    /**
     * Calls getBatchBalances() and getBatchAllowances() for each element of assetData.
     * @param ownerAddress Owner of the assets specified by assetData.
     * @param assetData Array of asset details, each encoded per the AssetProxy
     *     contract specification.
     * @returns An array of asset balances from getBalance(), and an array of asset allowances from getAllowance(), with each element corresponding to the same-indexed element in the assetData input.
     */
    DevUtilsContract.prototype.getBatchBalancesAndAssetProxyAllowances = function (ownerAddress, assetData) {
        var self = this;
        assert_1.assert.isString('ownerAddress', ownerAddress);
        assert_1.assert.isArray('assetData', assetData);
        var functionSignature = 'getBatchBalancesAndAssetProxyAllowances(address,bytes[])';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._performCallAsync(__assign({}, callData, { data: this.getABIEncodedTransactionData() }), defaultBlock)];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [ownerAddress.toLowerCase(), assetData]);
            },
        };
    };
    /**
     * Batch fetches ETH balances
     * @param addresses Array of addresses.
     * @returns Array of ETH balances.
     */
    DevUtilsContract.prototype.getEthBalances = function (addresses) {
        var self = this;
        assert_1.assert.isArray('addresses', addresses);
        var functionSignature = 'getEthBalances(address[])';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._performCallAsync(__assign({}, callData, { data: this.getABIEncodedTransactionData() }), defaultBlock)];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [addresses]);
            },
        };
    };
    DevUtilsContract.prototype.getOrderHash = function (order, chainId, exchange) {
        var self = this;
        assert_1.assert.isBigNumber('chainId', chainId);
        assert_1.assert.isString('exchange', exchange);
        var functionSignature = 'getOrderHash((address,address,address,address,uint256,uint256,uint256,uint256,uint256,uint256,bytes,bytes,bytes,bytes),uint256,address)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [order, chainId, exchange.toLowerCase()]);
            },
        };
    };
    /**
     * Fetches all order-relevant information needed to validate if the supplied order is fillable.
     * @param order The order structure.
     * @param signature Signature provided by maker that proves the order's
     *     authenticity. `0x01` can always be provided if the signature does not
     *     need to be validated.
     * @returns The orderInfo (hash, status, and &#x60;takerAssetAmount&#x60; already filled for the given order), fillableTakerAssetAmount (amount of the order&#x27;s &#x60;takerAssetAmount&#x60; that is fillable given all on-chain state), and isValidSignature (validity of the provided signature). NOTE: If the &#x60;takerAssetData&#x60; encodes data for multiple assets, &#x60;fillableTakerAssetAmount&#x60; will represent a &quot;scaled&quot; amount, meaning it must be multiplied by all the individual asset amounts within the &#x60;takerAssetData&#x60; to get the final amount of each asset that can be filled.
     */
    DevUtilsContract.prototype.getOrderRelevantState = function (order, signature) {
        var self = this;
        assert_1.assert.isString('signature', signature);
        var functionSignature = 'getOrderRelevantState((address,address,address,address,uint256,uint256,uint256,uint256,uint256,uint256,bytes,bytes,bytes,bytes),bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._performCallAsync(__assign({}, callData, { data: this.getABIEncodedTransactionData() }), defaultBlock)];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [order, signature]);
            },
        };
    };
    /**
     * Fetches all order-relevant information needed to validate if the supplied orders are fillable.
     * @param orders Array of order structures.
     * @param signatures Array of signatures provided by makers that prove the
     *     authenticity of the orders. `0x01` can always be provided if a signature
     *     does not need to be validated.
     * @returns The ordersInfo (array of the hash, status, and &#x60;takerAssetAmount&#x60; already filled for each order), fillableTakerAssetAmounts (array of amounts for each order&#x27;s &#x60;takerAssetAmount&#x60; that is fillable given all on-chain state), and isValidSignature (array containing the validity of each provided signature). NOTE: If the &#x60;takerAssetData&#x60; encodes data for multiple assets, each element of &#x60;fillableTakerAssetAmounts&#x60; will represent a &quot;scaled&quot; amount, meaning it must be multiplied by all the individual asset amounts within the &#x60;takerAssetData&#x60; to get the final amount of each asset that can be filled.
     */
    DevUtilsContract.prototype.getOrderRelevantStates = function (orders, signatures) {
        var self = this;
        assert_1.assert.isArray('orders', orders);
        assert_1.assert.isArray('signatures', signatures);
        var functionSignature = 'getOrderRelevantStates((address,address,address,address,uint256,uint256,uint256,uint256,uint256,uint256,bytes,bytes,bytes,bytes)[],bytes[])';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._performCallAsync(__assign({}, callData, { data: this.getABIEncodedTransactionData() }), defaultBlock)];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [orders, signatures]);
            },
        };
    };
    /**
     * Simulates all of the transfers within an order and returns the index of the first failed transfer.
     * @param order The order to simulate transfers for.
     * @param takerAddress The address of the taker that will fill the order.
     * @param takerAssetFillAmount The amount of takerAsset that the taker wished
     *     to fill.
     * @returns The index of the first failed transfer (or 4 if all transfers are successful).
     */
    DevUtilsContract.prototype.getSimulatedOrderTransferResults = function (order, takerAddress, takerAssetFillAmount) {
        var self = this;
        assert_1.assert.isString('takerAddress', takerAddress);
        assert_1.assert.isBigNumber('takerAssetFillAmount', takerAssetFillAmount);
        var functionSignature = 'getSimulatedOrderTransferResults((address,address,address,address,uint256,uint256,uint256,uint256,uint256,uint256,bytes,bytes,bytes,bytes),address,uint256)';
        return {
            sendTransactionAsync: function (txData, opts) {
                if (opts === void 0) { opts = { shouldValidate: true }; }
                return __awaiter(this, void 0, void 0, function () {
                    var txDataWithDefaults;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, self._applyDefaultsToTxDataAsync(__assign({}, txData, { data: this.getABIEncodedTransactionData() }), this.estimateGasAsync.bind(this))];
                            case 1:
                                txDataWithDefaults = _a.sent();
                                if (!(opts.shouldValidate !== false)) return [3 /*break*/, 3];
                                return [4 /*yield*/, this.callAsync(txDataWithDefaults)];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3: return [2 /*return*/, self._web3Wrapper.sendTransactionAsync(txDataWithDefaults)];
                        }
                    });
                });
            },
            awaitTransactionSuccessAsync: function (txData, opts) {
                if (opts === void 0) { opts = { shouldValidate: true }; }
                return self._promiseWithTransactionHash(this.sendTransactionAsync(txData, opts), opts);
            },
            estimateGasAsync: function (txData) {
                return __awaiter(this, void 0, void 0, function () {
                    var txDataWithDefaults;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, self._applyDefaultsToTxDataAsync(__assign({}, txData, { data: this.getABIEncodedTransactionData() }))];
                            case 1:
                                txDataWithDefaults = _a.sent();
                                return [2 /*return*/, self._web3Wrapper.estimateGasAsync(txDataWithDefaults)];
                        }
                    });
                });
            },
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._performCallAsync(__assign({}, callData, { data: this.getABIEncodedTransactionData() }), defaultBlock)];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [
                    order,
                    takerAddress.toLowerCase(),
                    takerAssetFillAmount,
                ]);
            },
        };
    };
    /**
     * Simulates all of the transfers for each given order and returns the indices of each first failed transfer.
     * @param orders Array of orders to individually simulate transfers for.
     * @param takerAddresses Array of addresses of takers that will fill each
     *     order.
     * @param takerAssetFillAmounts Array of amounts of takerAsset that will be
     *     filled for each order.
     * @returns The indices of the first failed transfer (or 4 if all transfers are successful) for each order.
     */
    DevUtilsContract.prototype.getSimulatedOrdersTransferResults = function (orders, takerAddresses, takerAssetFillAmounts) {
        var self = this;
        assert_1.assert.isArray('orders', orders);
        assert_1.assert.isArray('takerAddresses', takerAddresses);
        assert_1.assert.isArray('takerAssetFillAmounts', takerAssetFillAmounts);
        var functionSignature = 'getSimulatedOrdersTransferResults((address,address,address,address,uint256,uint256,uint256,uint256,uint256,uint256,bytes,bytes,bytes,bytes)[],address[],uint256[])';
        return {
            sendTransactionAsync: function (txData, opts) {
                if (opts === void 0) { opts = { shouldValidate: true }; }
                return __awaiter(this, void 0, void 0, function () {
                    var txDataWithDefaults;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, self._applyDefaultsToTxDataAsync(__assign({}, txData, { data: this.getABIEncodedTransactionData() }), this.estimateGasAsync.bind(this))];
                            case 1:
                                txDataWithDefaults = _a.sent();
                                if (!(opts.shouldValidate !== false)) return [3 /*break*/, 3];
                                return [4 /*yield*/, this.callAsync(txDataWithDefaults)];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3: return [2 /*return*/, self._web3Wrapper.sendTransactionAsync(txDataWithDefaults)];
                        }
                    });
                });
            },
            awaitTransactionSuccessAsync: function (txData, opts) {
                if (opts === void 0) { opts = { shouldValidate: true }; }
                return self._promiseWithTransactionHash(this.sendTransactionAsync(txData, opts), opts);
            },
            estimateGasAsync: function (txData) {
                return __awaiter(this, void 0, void 0, function () {
                    var txDataWithDefaults;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, self._applyDefaultsToTxDataAsync(__assign({}, txData, { data: this.getABIEncodedTransactionData() }))];
                            case 1:
                                txDataWithDefaults = _a.sent();
                                return [2 /*return*/, self._web3Wrapper.estimateGasAsync(txDataWithDefaults)];
                        }
                    });
                });
            },
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._performCallAsync(__assign({}, callData, { data: this.getABIEncodedTransactionData() }), defaultBlock)];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [orders, takerAddresses, takerAssetFillAmounts]);
            },
        };
    };
    DevUtilsContract.prototype.getTransactionHash = function (transaction, chainId, exchange) {
        var self = this;
        assert_1.assert.isBigNumber('chainId', chainId);
        assert_1.assert.isString('exchange', exchange);
        var functionSignature = 'getTransactionHash((uint256,uint256,uint256,address,bytes),uint256,address)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [transaction, chainId, exchange.toLowerCase()]);
            },
        };
    };
    /**
     * Gets the amount of an asset transferable by the owner.
     * @param ownerAddress Address of the owner of the asset.
     * @param assetData Description of tokens, per the AssetProxy contract
     *     specification.
     * @returns The amount of the asset tranferable by the owner. NOTE: If the &#x60;assetData&#x60; encodes data for multiple assets, the &#x60;transferableAssetAmount&#x60; will represent the amount of times the entire &#x60;assetData&#x60; can be transferred. To calculate the total individual transferable amounts, this scaled &#x60;transferableAmount&#x60; must be multiplied by the individual asset amounts located within the &#x60;assetData&#x60;.
     */
    DevUtilsContract.prototype.getTransferableAssetAmount = function (ownerAddress, assetData) {
        var self = this;
        assert_1.assert.isString('ownerAddress', ownerAddress);
        assert_1.assert.isString('assetData', assetData);
        var functionSignature = 'getTransferableAssetAmount(address,bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._performCallAsync(__assign({}, callData, { data: this.getABIEncodedTransactionData() }), defaultBlock)];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [ownerAddress.toLowerCase(), assetData]);
            },
        };
    };
    DevUtilsContract.prototype.revertIfInvalidAssetData = function (assetData) {
        var self = this;
        assert_1.assert.isString('assetData', assetData);
        var functionSignature = 'revertIfInvalidAssetData(bytes)';
        return {
            callAsync: function (callData, defaultBlock) {
                if (callData === void 0) { callData = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var rawCallResult, abiEncoder;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);
                                return [4 /*yield*/, self._evmExecAsync(this.getABIEncodedTransactionData())];
                            case 1:
                                rawCallResult = _a.sent();
                                abiEncoder = self._lookupAbiEncoder(functionSignature);
                                return [2 /*return*/, abiEncoder.strictDecodeReturnValue(rawCallResult)];
                        }
                    });
                });
            },
            getABIEncodedTransactionData: function () {
                return self._strictEncodeArguments(functionSignature, [assetData]);
            },
        };
    };
    /**
     * @ignore
     */
    DevUtilsContract.deployedBytecode = '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';
    DevUtilsContract.contractName = 'DevUtils';
    return DevUtilsContract;
}(base_contract_1.BaseContract));
exports.DevUtilsContract = DevUtilsContract;
// tslint:disable:max-file-line-count
// tslint:enable:no-unbound-method no-parameter-reassignment no-consecutive-blank-lines ordered-imports align
// tslint:enable:trailing-comma whitespace no-trailing-whitespace
//# sourceMappingURL=dev_utils.js.map